import Vue from 'vue'
import vueScroll from 'vue_scroll'
import Router from 'vue-router'
import App from './components/App.vue'
import WelcomeView from './components/Welcome.vue'
import NoticeDetailView from './components/NoticeDetail.vue'
import ArticleDetailView from './components/ArticleDetail.vue'
import NoticeView from './components/notice/MyNoticeDetail.vue'
import QaDetailView from './components/notice/QaNoticeDetail.vue'
import VueConfig from 'vue-config'
// import SearchView from './components/Search/Search2.vue'
import ResultView from './components/Search/Result2.vue'       // 信批结果页
import SearchView from './components/Search/Search.vue'        // 信批搜索页
import AdvSearchView from './components/Search/AdvSearch.vue'   // 深度搜索页
import LimitView from './components/Search/Limit.vue'
import MyArticleDetailView from './components/MyArticleDetail.vue'
import EventMessage from './components/eventMessage.vue'
import NewMessage from './components/newMessage.vue'
import MySubscribe from './components/MySubscribe.vue'
import FinanceDetail from './components/finance.vue'
import StockPledgeView from './components/dhy/StockPledge.vue'

// 公司信息
import companyApp from './components/company/App.vue'
import companyBaseInfo from './components/company/BaseInfo.vue'
import companyGaoGuan from './components/company/GaoGuan.vue'
import companyInvest from './components/company/Invest.vue'
import companyTopTenGuDong from './components/company/GuDongTop10.vue'
import companyShareChange from './components/company/ShareChange.vue'
import companyMainProduct from './components/company/Product.vue'
import companyMainIndustry from './components/company/Industry.vue'
import companyMainLocation from './components/company/Location.vue'
import companyCustomer from './components/company/Customer.vue'
import companySupplier from './components/company/Supplier.vue'
import companyStockTop from './components/company/StockTops.vue'
import companyLargeexChange from './components/company/LargeexChange.vue'
import companyTradeInfo from './components/company/TradeInfo.vue'
import companyFiance from './components/company/Finance.vue'
import companyFzb from './components/company/Fzb.vue'
import companyLrb from './components/company/Lrb.vue'
import companyLlb from './components/company/Llb.vue'
import companyPerformance from './components/company/Performance.vue'
import companyIndustryCompare from './components/company/IndustryCompare.vue'

const configs = {
  host: {
    download: 'fs.ibdata.cn',
    batchdownload: 'fs.ibdata.cn:9007',
    mobile: 'wx.ibdata.cn',
    bind: 'www.ibdata.cn'    // 微信绑定
    // bind: '10.0.0.116:9001'            // 微信绑定
    // bind: '192.168.1.102:9001'      // 微信绑定
    // bind: '192.168.1.115:9001'      // 微信绑定
  },
  weixin: {
    // appid: 'wx6bc2698b4c52c49d'
    // appid: 'wxb762b2313cbea358'
    // appid: 'wxe159ef3eae2d81fe'   // 测试号
    appid: 'wxb762b2313cbea358'   // 生产， 118
    // appid: 'wxbb8c32446df29c9b'   // 自己的
  }
}
Vue.use(VueConfig, configs)

var ajax = $.ajax;
$.ajax = function (opt) {
  // 备份opt中error和success方法
  var fn = {
    success: function (data, textStatus, jqXHR) {
    }
  }
  if (opt.success) {
    fn.success = opt.success
  }
  var def = ajax.call($, opt)
  console.log(opt)                                                                                                                            // 兼容不支持异步回调的版本
  if ('done' in def) {
    console.log(def)
    if (opt.url.indexOf('profile') < 0 && opt.url.indexOf('taglist') < 0 && opt.url.indexOf('keywords') < 0) {
      var done = def.done
      def.done = function (func) {
        function _done (data) {
          if (data.status === '403') {
            alert('登录已过期，请重新登录')
            setTimeout(function () {
              window.location.reload()
            }, 1000)
            return
          }
          if (data.status === '401') {
            window.location.href = '/#!/limit?typ=1'
            return
          }
          if (data.status === '402') {
            window.location.href = '/#!/limit?typ=2'
            return
          }
          func(data)
        }

        done.call(def, _done)
        return def
      }
    }
  }
  return def
}
Vue.use(Router)
Vue.use(vueScroll)

Vue.filter('maxlen', function (value, len) {
  if (value.length > len) {
    return value.substr(0, len) + '...'
  }
  return value
})

Vue.filter('trim', function (value) {
  return value.trim()
})

Vue.filter('time', function (t) {
  if (t) {
    let a = t.replace('T', ' ')
    let n = a.substr(0, 16)
    return n
  }
})

Vue.filter('money', function (z) {
  // if (!num) {
  //   return num
  // } else {
  //   return num.toLocaleString('en-US')
  // }
  if (!z) {
    return z
  } else {
    let num = z.toString()
    let normdata = ''
    if (num.indexOf('.') !== -1) {
      normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ","
      })

    } else {
      normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function($0, $1) {
        return $1 + ","
      })
    }
    if (normdata.indexOf('.') >= 0) {
      let arr = normdata.split('.')
      if (arr[1].length < 2) {
        return normdata + '0'
      } else {
        return normdata.substr(0, normdata.indexOf('.') + 3)
      }
      // return arr[0] + '.' + arr[1]
    } else {
      return normdata
    }
  }
})
Vue.filter('date', function (value) {
  var d = value.substr(0, 10)
  return d
})
Vue.filter('percent', function (num) {
  if (!num) {
    return num;
  } else {
    num = parseFloat(num);
    return num.toFixed(2);
  }
})

// routing
let router = new Router()

router.map({
  '/': {
    name: 'WelcomeView',
    component: WelcomeView
  },
  '/notice/detail': {
    name: 'NoticeDetailView',
    component: NoticeDetailView
  },
  '/article-detail/:id': {
    name: 'ArticleDetailView',
    component: ArticleDetailView
  },
  '/notice-detail/:id': {
    name: 'NoticeView',
    component: NoticeView
  },
  '/eventmsg/:id': {
    name: 'EventMessage',
    component: EventMessage
  },
  '/newmessage': {
    name: 'NewMessage',
    component: NewMessage
  },
  '/mysubscribe': {
    name: 'MySubscribe',
    component: MySubscribe
  },
  '/qaview/:id': {
    name: 'QaDetailView',
    component: QaDetailView
  },
  '/search': {
    name: 'SearchView',
    component: SearchView
  },
  '/result': {
    name: 'ResultView',
    component: ResultView
  },
  '/advsearch': {
    name: 'AdvSearchView',
    component: AdvSearchView
  },
  '/limit': {
    name: 'LimitView',
    component: LimitView
  },
  '/myarticle/:id': {
    name: 'MyArticleDetailView',
    component: MyArticleDetailView
  },
  '/financedetail': {
    name: 'FinanceDetail',
    component: FinanceDetail
  },
  '/stockpledge': {
    name: 'StockPledgeView',
    component: StockPledgeView
  },
  '/company': {
    name: 'companyApp',
    component: companyApp,
    subRoutes: {
      '/': {
        name: 'companyBaseInfo',
        component: companyBaseInfo
      },
      '/gaoguan': {
        name: 'companyGaoGuan',
        component: companyGaoGuan
      },
      '/invest': {
        name: 'companyInvest',
      component: companyInvest
      }, 
      '/topten': {
        name: 'companyTopTenGuDong',
        component: companyTopTenGuDong
      },
      '/sharechange': {
        name: 'companyShareChange',
        component: companyShareChange
      },
      '/mainproduct': {
        name: 'companyMainProduct',
        component: companyMainProduct
      },
      '/mainindustry': {
        name: 'companyMainIndustry',
        component: companyMainIndustry
      },
      '/mainlocation': {
        name: 'companyMainLocation',
        component: companyMainLocation
      },
      '/customer': {
        name: 'companyCustomer',
        component: companyCustomer
      },
      '/supplier': {
        name: 'companySupplier',
        component: companySupplier
      },
      '/stocktops': {
        name: 'companyStockTop',
        component: companyStockTop
      },
      '/largeexchange': {
        name: 'companyLargeexChange',
        component: companyLargeexChange
      },
      '/tradeinfo': {
        name: 'companyTradeInfo',
        component: companyTradeInfo
      },
      '/finance': {
        name: 'companyFiance',
        component: companyFiance
      },
      '/fzb': {
        name: 'companyFzb',
        component: companyFzb
      },
      '/lrb': {
        name: 'companyLrb',
        component: companyLrb
      },
      '/llb': {
        name: 'companyLlb',
        component: companyLlb
      },
      '/performance': {
        name: 'companyPerformance',
        component: companyPerformance
      },
      '/industryCompare': {
        name: 'companyIndustryCompare',
        component: companyIndustryCompare
      },
    }
  }
})

router.start(App, 'app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/